module.exports = __webpack_public_path__ + "BMRpayslip.3d4d5d3.jpg";